// The corpus a non-open-ended block draws its cloud from.
//
// A question that has batches or answer variants can be shown as a word cloud instead of its chart:
// each batch (or variant) becomes one word, weighted by its own amount. Ported from the block base
// that builds this corpus for the open-ended view it hands over to on the live page — including its
// raw-data mode, where the words go to the cloud unprocessed.

import {
  removeLogicFromText,
  removeTagsFromText
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/textUtils'

const cleanText = text => removeTagsFromText(removeLogicFromText(text || ''))

// Word tuple: [text, weight, stop-level, junk]. A block word is never a stop word and never junk.
const wordOf = (text, weight) => [cleanText(text), weight || 0, 0, false]

const variantAmount = (entry, rType) => (null == rType || 'cases' === rType ? entry?.amount : entry?.respAmount) || 0

const batchAmount = (entry, type, rType) =>
  ('md' === type ? entry?.varyingProbability : variantAmount(entry, rType)) || 0

/**
 * @param {Object} args
 * @param {string} [args.type] - question type; max-diff weights its batches by probability instead
 * @param {Object} [args.answer] - the answer bag the per-batch / per-variant amounts hang off
 * @param {Array} [args.batches] - batches, which win over variants when the question has both
 * @param {Array} [args.answerVariants] - answer variants
 * @param {string} [args.rType] - 'cases' counts answers, anything else counts respondents
 * @returns {Array} word tuples for the cloud's raw-data mode
 */
export const buildBlockWords = ({ type, answer = {}, batches, answerVariants, rType = 'cases' } = {}) => {
  if (0 < batches?.length) {
    return batches.filter(Boolean).map(b => wordOf(b.text, batchAmount(answer[`b${b.position}`], type, rType)))
  }

  if (0 < answerVariants?.length) {
    return answerVariants.filter(Boolean).map(av => wordOf(av.text, variantAmount(answer[`a${av.position}`], rType)))
  }

  return []
}

export default buildBlockWords
